import React, { useEffect, useState } from "react";
import "./UtcIstClock.css";

const pad = value => String(value).padStart(2, "0");

const formatIsoParts = date =>
  `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`
  + `T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;

export const formatUtcTime = date => `${formatIsoParts(date)}Z`;

export const formatIndiaTime = date =>
  `${formatIsoParts(new Date(date.getTime() + (330 * 60 * 1000)))}+05:30`;

const UtcIstClock = ({ compact = false }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`global-time-display${compact ? " global-time-display--compact" : ""}`}
      aria-label="Current UTC and India time"
    >
      <span>
        <strong>UTC</strong>
        <time dateTime={formatUtcTime(now)}>{formatUtcTime(now)}</time>
      </span>
      <span>
        <strong>{compact ? "IST" : "India"}</strong>
        <time dateTime={formatIndiaTime(now)}>{formatIndiaTime(now)}</time>
      </span>
    </div>
  );
};

export default UtcIstClock;
